import { request } from './client';

export const userService = {
  getUsers: () => request('/users'),
  
  // Fetch available roles (Required for Category Manager)
  getRoles: () => request('/roles'),

  getUsersByRole: async (roleKey) => {
    const allUsers = await request('/users');
    return allUsers.filter(user => (user.role_key || user.role) === roleKey);
  },

  createUser: (userData) => request('/users', { method: 'POST', body: userData }),
  
  updateUser: (id, userData) => request(`/users/${id}`, { method: 'PUT', body: userData }),
  
  deleteUser: (id) => request(`/users/${id}`, { method: 'DELETE' }),
  
    // Get organisations assigned to a specific user
  getUserAssignedOrgs: (userId) => request(`/users/${userId}/assigned-organisations`),

  // Update the list of organisations assigned to a user
  updateUserAssignedOrgs: (userId, organisationIds) => 
    request(`/users/${userId}/assigned-organisations`, { 
      method: 'POST', 
      body: { organisationIds } 
    }),
};
